import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchCheckEmailAddressDefault = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'checkEmailAddressDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      email: payload.email,
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchMrdContactsDefault = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllContactsForContactGroupDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      contactGroupCode: 'IPC',
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchIpcContacts = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllContactsForContactGroupDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      contactGroupCode: 'IPC',
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchMrdContacts = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllContactsForContactGroupDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      contactGroupCode: 'MRD',
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceURL);
};

export const apiFetchXmlContacts = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllContactsForContactGroupDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      contactGroupCode: 'DATA_SHARING',
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiDeleteContact = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'deleteContactDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.delete(serviceURL, { data: payload });
};

export const apiGetDataLocationListDefault = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDataLocationListDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiGetContactByEmailDefault = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getContactDetailsByEmailAddressDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      email: payload.email,
    },
  });
  return axios.get(serviceURL, payload);
};
